import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { History, Location, createBrowserHistory } from 'history';
import locale, { langAll } from 'locales';
import routes, { RouteTs } from 'config/routes';
import Layout from 'styles/layout/default';

const baseUrl = process.env.PUBLIC_URL;
const history = createBrowserHistory({ basename: baseUrl });
const pathname = location.pathname;
const curLang = langAll.filter(item => pathname.indexOf(item) > 0 && item);
const navLang = langAll.filter(item => navigator.language === item && item);
localStorage.setItem('lang', curLang[0] || navLang[0] || 'ko-KR');
const lang = localStorage.getItem('lang') || 'ko-KR';
// const curRoute = routes.filter(item => item.path.indexOf(pathname.replace(`/${lang}`, '')) >= 0);


interface Iprops {
  path: string;
  component: React.FunctionComponent;
  lang: string;
  name: string;
  messages: IMsg;
  location?: Location;
  computedMatch?: Imatcg;
  exact: boolean;
  children?: React.ReactNode;
  history: History;
};

interface IMsg {
  title: string;
}

interface Imatcg {
  path: string;
  url: string;
  isExact: boolean;
  params: object;
};

interface IProvide {
  history: History;
}

const routesAll = langAll.reduce((acc: object[], obj: string, index: number, arr: string[]) => {
  routes.forEach(item => {
    !index && acc.push(item)

    item = {
      ...item,
      path: '/' + obj + (item.path === '/' ? '' : item.path),
    }

    acc.push(item);
  })
  return acc;
}, []);

const BindRoute = ({ component: Component, path, ...rest }: Iprops) => {
  const { messages, location, computedMatch } = rest;

  document.title = messages.title || locale[lang].home.title;

  if (location && location.pathname.indexOf(lang) < 0) {
    window.history.replaceState({}, '', `${baseUrl}/${lang}${computedMatch && computedMatch.url.replace(`/${lang}`, '')}`);
  }

  return <Route path={path} {...rest} render={props => <Component {...rest} {...props} />}/>
};

const Routes = (props: IProvide) => (
  <Layout messages={locale[lang].common} lang={lang}>
  {/* <Layout meta={curRoute && curRoute[0].meta} messages={locale[lang].common} lang={lang}> */}
    <Switch>
      {
        routesAll.map(({ path, component, name }: RouteTs, index: number) => (
          <BindRoute
            {...props}
            exact={true}
            lang={lang}
            path={path}
            component={component}
            messages={locale[lang][name]}
            name={name}
            key={index}
          />
        ))
      }
    </Switch>
  </Layout>
);

const App = () => (
  <BrowserRouter>
    <Routes history={history} />
  </BrowserRouter>
);



export default App;


// WEBPACK FOOTER //
// ./src/route.tsx